import { render, staticRenderFns } from "./BusinessMain.vue?vue&type=template&id=55d1a176&"
import script from "./BusinessMain.vue?vue&type=script&lang=js&"
export * from "./BusinessMain.vue?vue&type=script&lang=js&"
import style0 from "./BusinessMain.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports